import { Skeleton } from 'antd';
import { InfiniteScroll, InputSearch } from 'components/common';
import { RightSideCheckboxV2 } from 'components/common/checkbox';
import { useRolesOptions } from 'hooks/roles';
import { uniqBy } from 'lodash';
import { rolesMessages } from 'messages';
import { useState } from 'react';
import { FindAllRoleDto, RoleCompactDto } from 'types';

type CheckboxRolesProps = Omit<FindAllRoleDto, 'keyword' | 'pageIndex' | 'pageSize'> & {
  value?: RoleCompactDto[];
  onChange: (value: RoleCompactDto[]) => void;
  organizationUnitIds?: number[];
};

const CheckboxRoles = ({ value, onChange, organizationUnitIds }: CheckboxRolesProps) => {
  const [keyword, setKeyword] = useState('');

  const { roleOptions, handleLoadMore, isLoading, isFetching, hasMore, resetPage } = useRolesOptions({
    keyword,
    organizationUnitIds
  });

  const handleSearch = (val: string) => {
    resetPage();
    setKeyword(val);
  };

  const formatData = (data: RoleCompactDto[]): any[] => {
    if (data.length === 0) return [];

    return data.map((item) => ({
      key: item.roleId.toString(),
      value: item.roleId.toString(),
      label: item.name
    }));
  };

  const handleChange = (selectedValue: string[]) => {
    const selectedIds = selectedValue.map((val) => Number(val));
    const selectedRoles = uniqBy([...(value || []), ...roleOptions], 'roleId').filter((opt) =>
      selectedIds.includes(opt.roleId)
    );
    onChange(selectedRoles);
  };
  return (
    <div>
      <InputSearch
        className='mb-6 rounded-lg border'
        placeholder={rolesMessages.name}
        onChange={(e) => handleSearch(e.toString())}
      />
      <InfiniteScroll
        loader={<Skeleton active={isLoading} title={false} paragraph={{ rows: 5 }} />}
        hasMore={hasMore}
        next={handleLoadMore}
        isLoading={isLoading || isFetching}
      >
        <RightSideCheckboxV2
          options={formatData(roleOptions)}
          onChange={handleChange}
          value={value?.map((item) => item.roleId.toString())}
          split
        />
      </InfiniteScroll>
    </div>
  );
};

export default CheckboxRoles;
